import { FC } from 'react'

const MaterialTaxonomy: FC = () => {
  return (
    <div className="p-8">
      <h1 className="mb-4 text-2xl font-bold">Material Taxonomy</h1>
      <p className="text-gray-600">Coming Soon</p>
    </div>
  )
}

export default MaterialTaxonomy
